import badSistersLarge from '../../assets/images/carousel/main/bad sisters large.jpg';
import badSistersMedium from '../../assets/images/carousel/main/bad sisters medium.jpg';
import badSistersSmall from '../../assets/images/carousel/main/bad sisters small.jpg';
import badSistersMobile from '../../assets/images/carousel/mobile/bad sisters mobile.jpg';

import pachinkoLarge from '../../assets/images/carousel/main/pachinko large.jpg';
import pachinkoMedium from '../../assets/images/carousel/main/pachinko medium.jpg';
import pachinkoSmall from '../../assets/images/carousel/main/pachinko small.jpg';
import pachinkoMobile from '../../assets/images/carousel/mobile/pachinko mobile.jpg';

import luckLarge from '../../assets/images/carousel/main/luck large.jpg';
import luckMedium from '../../assets/images/carousel/main/luck medium.jpg';
import luckSmall from '../../assets/images/carousel/main/luck small.jpg';
import luckMobile from '../../assets/images/carousel/mobile/luck mobile.jpg';

import tedLarge from '../../assets/images/carousel/main/ted lasso large.jpg';
import tedMedium from '../../assets/images/carousel/main/ted lasso medium.jpg';
import tedSmall from '../../assets/images/carousel/main/ted lasso small.jpg';
import tedMobile from '../../assets/images/carousel/mobile/ted lasso mobile.jpg';

import fdmLarge from '../../assets/images/carousel/main/five days at memorial large.jpg';
import fdmMedium from '../../assets/images/carousel/main/five days at memorial medium.jpg';
import fdmSmall from '../../assets/images/carousel/main/five days at memorial small.jpg';
import fdmMobile from '../../assets/images/carousel/mobile/five days at memorial mobile.jpg';

import severanceLarge from '../../assets/images/carousel/main/severance large.jpg';
import severanceMedium from '../../assets/images/carousel/main/severance medium.jpg';
import severanceSmall from '../../assets/images/carousel/main/severance small.jpg';
import severanceMobile from '../../assets/images/carousel/mobile/severance mobile.jpg';

import planetLarge from '../../assets/images/carousel/main/prehistoric planet large.jpg';
import planetMedium from '../../assets/images/carousel/main/prehistoric planet medium.jpg';
import planetSmall from '../../assets/images/carousel/main/prehistoric planet small.jpg';
import planetMobile from '../../assets/images/carousel/mobile/prehistoric planet mobile.jpg';

import seeLarge from '../../assets/images/carousel/main/see large.jpg';
import seeMedium from '../../assets/images/carousel/main/see medium.jpg';
import seeSmall from '../../assets/images/carousel/main/see small.jpg';
import seeMobile from '../../assets/images/carousel/mobile/see mobile.jpg';

import shanLarge from '../../assets/images/carousel/main/shantaram large.jpg';
import shanMedium from '../../assets/images/carousel/main/shantaram medium.jpg';
import shanSmall from '../../assets/images/carousel/main/shantaram small.jpg';
import shanMobile from '../../assets/images/carousel/mobile/shantaram mobile.jpg';

export const carouselImages = [
	{
		large: badSistersLarge,
		medium: badSistersMedium,
		small: badSistersSmall,
		mobile: badSistersMobile,
		alt: 'Bad Sisters',
	},
	{
		large: pachinkoLarge,
		medium: pachinkoMedium,
		small: pachinkoSmall,
		mobile: pachinkoMobile,
		alt: 'Pachinko',
	},
	{
		large: luckLarge,
		medium: luckMedium,
		small: luckSmall,
		mobile: luckMobile,
		alt: 'Luck',
	},
	{
		large: tedLarge,
		medium: tedMedium,
		small: tedSmall,
		mobile: tedMobile,
		alt: 'Ted Lasso',
	},
	{
		large: fdmLarge,
		medium: fdmMedium,
		small: fdmSmall,
		mobile: fdmMobile,
		alt: 'Five Days at Memorial',
	},
	{
		large: planetLarge,
		medium: planetMedium,
		small: planetSmall,
		mobile: planetMobile,
		alt: 'Pre Historic Planet',
	},
	{
		large: seeLarge,
		medium: seeMedium,
		small: seeSmall,
		mobile: seeMobile,
		alt: 'See',
	},
	{
		large: shanLarge,
		medium: shanMedium,
		small: shanSmall,
		mobile: shanMobile,
		alt: 'Shantaram',
	},
	{
		large: severanceLarge,
		medium: severanceMedium,
		small: severanceSmall,
		mobile: severanceMobile,
		alt: 'Severance',
	},
];
